var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 25.0203C50.0095 15.31 43.0424 6.99599 33.4802 5.30682C23.9179 3.61765 14.5241 9.04147 11.2062 18.1674C7.88835 27.2932 11.6054 37.4837 20.0197 42.3303C23.7706 44.4946 24.7816 46.8833 29.0347 54.425C29.2316 54.7742 29.6015 54.9902 30.0024 54.9902C30.4033 54.9902 30.7731 54.7742 30.9701 54.425C35.2676 46.8011 36.2409 44.4901 39.9829 42.3303C46.1801 38.7698 50.0008 32.1675 50 25.0203Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 33.9088V28.3536C26.668 26.5128 28.1603 25.0205 30.0011 25.0205C31.842 25.0205 33.3343 26.5128 33.3343 28.3536V33.9088",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.224 20.9805V33.9085H37.7785V20.9805",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7797 25.0206L30.0011 13.9102L42.2225 25.0206",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon-address.91720f1f.svg";
export { ForwardRef as ReactComponent };